import * as React from 'react';
import { theme } from '../../../theme';

interface Props {
  color?: string;
}

export const RefreshIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3382 1.83398V3.92211C13.3382 4.11802 13.0932 4.2067 12.9678 4.0562C11.7471 2.69232 9.97316 1.83398 7.9987 1.83398C4.3168 1.83398 1.33203 4.81875 1.33203 8.50065C1.33203 12.1825 4.3168 15.1673 7.9987 15.1673C11.6806 15.1673 14.6654 12.1825 14.6654 8.50065"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
